'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { MdChevronRight } from 'react-icons/md';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { useState } from 'react';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export const ReferencesList = ({ references }: { references: Reference[] }) => {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    // Check if images is already an array and has the correct index
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.reverse().slice(index), ...images.reverse().slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      // If images is not an array, it means it's a single image object. Wrap it in an array.
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <section className={cn('flex w-full items-center justify-center px-6')}>
        <div
          className={cn(
            'ea-container--screen-xl',
            'grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3',
          )}
        >
          {references.map(reference => (
            <div
              key={reference.name}
              className="col-span-1 flex w-full cursor-pointer flex-col items-start justify-start gap-5"
              onClick={handleOpenGallery(reference.images, 0)}
            >
              <div className="relative h-[300px] w-full">
                <Image
                  src={reference?.image?.url ?? '/images/placeholder.png'}
                  alt={resolveImageAlt(reference?.image, reference?.name)}
                  fill
                  style={{ objectFit: 'cover', objectPosition: 'center' }}
                  sizes="(min-width: 640px) 50vw, 100vw"
                />
              </div>
              <div className="flex w-full flex-col items-start justify-start gap-2">
                <h4 className="line-clamp-2 h-[58px] text-xl font-bold sm:h-[60px] sm:text-2xl">
                  {reference.name}
                </h4>
                <HtmlRendererRaw
                  className={cn('ea-universal__description line-clamp-2', ' w-full')}
                  html={reference.description}
                />
              </div>
              <span className="flex items-center justify-start gap-3 text-base font-bold uppercase text-primary">
                Otvoriť galériu <MdChevronRight size={24} />
              </span>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};
